<template>
	<div class="hairdetail">
		<div class="td">发型师管理</div>
		<div class="nav-bar">
			<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
				<el-tab-pane label="发型师信息" name="first">
					<hair-information></hair-information>
				</el-tab-pane>
				<el-tab-pane label="业绩统计" name="second" :lazy="true">
					<hairAchievement></hairAchievement>
				</el-tab-pane>
				<el-tab-pane label="考勤统计" name="third">
					<hair-attendance></hair-attendance>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
	import hairInformation from './childdetail/hairInformation'
	import hairAttendance from './childdetail/hairAttendance'
	import hairAchievement from './childdetail/hairAchievement'
	export default {
		name: "hairdetail",
		components: {
			hairInformation,
			hairAttendance,
			hairAchievement
		},
		data() {
			return {
				activeName: "first",
			};
		},
		methods: {
			handleClick(tab, event) {
				console.log(tab, event);
			},
		},
	};
</script>

<style>
	.hairdetail .td {
		margin-bottom: 40px;
	}
</style>